import React from 'react';
import PropTypes from 'prop-types';

const OpenFileLink = ({ href, children, isButton }) => {
  return isButton ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="ant-btn ant-btn-sm"
      style={{ lineHeight: '40px' }}
    >
      {children}
    </a>
  ) : (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

OpenFileLink.propTypes = {
  isButton: PropTypes.bool,
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default OpenFileLink;



// WEBPACK FOOTER //
// ./src/common/components/data-display/OpenFileLink.js